// // https://primeng.org/theming/styled

import Lara from '@primeuix/themes/lara';
import { definePreset } from '@primeuix/themes';

const embarkBlueScale = {
	50: '#e6f0f9',
	100: '#cce1f3',
	200: '#99c3e7',
	300: '#66a5db',
	400: '#3387cf',
	500: '#0063a8',
	600: '#005590',
	700: '#004778',
	800: '#003960',
	900: '#002b48',
	950: '#001a2c',
};

export const primengPreset = definePreset(Lara, {
	semantic: { primary: embarkBlueScale },
});
